import React, { useState } from "react";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SnackbarAlert from "../snackbar-alert/SnackbarAlert";
import "../../components/style.scss";
import "./AmountModal.scss";

function ExcessAmountModal({ closePopup, handleExcessAmount,message }) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(true);

  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(!openModal);
        }}
        hideBackdrop={true}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="UploadDetailsModalSignature"
      >
        <Box
          className="modalContainerSignature"
          sx={{
            width: { xs: "90%", sm: "80%", md: "70%", lg: "50%" },
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 1,
            p: 4,
          }}
        >
          <Box sx={{ border: "0" }}>
            <div className="closeModal" onClick={() => closePopup(false)}>
              <HighlightOffIcon />
            </div>
            <Typography
              className="modalTitleSignature"
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Confirm Payment Amount
            </Typography>
            
              <Typography
                className="amountTitleSignature"
                sx={{ textAlign: "center" }}
              >
                {message}
              </Typography>
              <Typography
                className="amountTitleSignature"
                sx={{ textAlign: "center" }}
              >
                Are you sure you would like to proceed?
              </Typography>
          </Box>

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 5,
            }}>
                <Button
                  sx={{
                    width: "157px",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={handleExcessAmount}
                >
                  Yes
                </Button>
                <Button
                  sx={{
                    width: "157px",
                    height: "48px",
                    borderRadius: "8px",
                    border: "1px solid #1A407D",
                    color: "#1A407D",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#E3EAF5",
                    },
                  }}
                  onClick={() => closePopup(false)}
                >
                  No
                </Button>
            </Box>
        </Box>
      </Modal>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
}

export default ExcessAmountModal;